import { render, staticRenderFns } from "./production-remark.modal.vue?vue&type=template&id=021cc846&"
import script from "./production-remark.modal.vue?vue&type=script&lang=ts&"
export * from "./production-remark.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports